require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/es7.symbol.observable.js
// module id = 400
// module chunks = 37